<!--  Statistics Widget-->
<div class="widget statistics-widget" id="customer-info-event-statistics">
  <div class="header">
    <div class="title flex between align-center" style="padding:10px 20px">
      <nav class="nav">
        <ul class="dropdown-area" #statisticsDropdown>
          <li>
            <div class="dropdown-label flex-row between title" (click)="toggleStatisticsDropDownMenu()">
              <div>{{statisticsType.curType}}</div>
              <div class="flex align-center ml-4">
                <comp-icon class="transition" [icon]="'expend_more'" [size]="'16'" [color]="'hsla(0, 0%, 0%, 1)'" [class.rotate-reverse]="statisticsType.dropdown.isShow"></comp-icon>
              </div>
            </div>
            <div class="dropdown-box" *ngIf="statisticsType.dropdown.isShow">
              <ul class="dropdown-box-menu">
                <li class="dropdown-box-menu-item" *ngFor="let statisType of statisticsType.types" [class.selected]="statisType === statisticsType.curType" (click)="changeStatisticsType(statisType)">
                  <div class="dropdown-box-menu-item-icon">
                    <comp-icon [icon]="'done'" [size]="'14'" [color]="'hsl(210, 100%, 56%)'" *ngIf="statisType === statisticsType.curType"></comp-icon>
                  </div>
                  <div>{{statisType}}</div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
      <nav class="nav">
        <ul class="dropdown-area" #statisticsRangeDropdown>
          <li>
            <div class="dropdown-label flex-row between" (click)="toggleStatisticsRangeDropDownMenu()">
              <div>{{staticsticsData.timeData.range}}</div>
              <div class="flex align-center ml-4">
                <comp-icon class="transition" [icon]="'expend_more'" [size]="'16'" [color]="'hsla(0, 0%, 0%, 1)'" [class.rotate-reverse]="staticsticsData.dropdown.isShow"></comp-icon>
              </div>
            </div>
            <div class="dropdown-box" *ngIf="staticsticsData.dropdown.isShow">
              <ul class="dropdown-box-menu">
                <li class="dropdown-box-menu-item" *ngFor="let item of timeRanges" [class.selected]="item.label === staticsticsData.timeData.range" (click)="changeStatisticsTimeRange(item.label)">
                  <div class="dropdown-box-menu-item-icon">
                    <comp-icon [icon]="'done'" [size]="'14'" [color]="'hsl(210, 100%, 56%)'" *ngIf="item.label === staticsticsData.timeData.range"></comp-icon>
                  </div>
                  <div>{{item.label}}</div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <!--  Event Statistics-->
  <div *ngIf="statisticsType.curType === statisticsType.types[0]">
    <div class="statistics-widget-contents flex-row flex-wrap">
      <!--  Video Event Chart-->
      <div class="statistics-widget-contents-box flex-group-2">
        <div class="statistics-widget-contents-box-title">
          <div class="flex">
            <div class="mr-5">Video Clips</div>
          </div>
        </div>
        <div *ngIf="staticsticsData.videoEvents.chartData.data.length !== 0">
          <div class="flex-row between">
            <div class="statistics-widget-contents-box-count">{{!staticsticsData.videoEvents.isHovered ? staticsticsData.videoEvents.count : staticsticsData.videoEvents.hoverLabel}}</div>
            <div class="v-center">
              <mat-slide-toggle [(ngModel)]="isIncludesOtherEvents" [labelPosition]="'after'" (change)="changeIsIncluded()" style="font-size: 12px;transform: scale(0.9);"><span class="default-label">{{isIncludesOtherEvents ? 'All Video Clips' : 'Video Alarm CIips'}}</span></mat-slide-toggle>
              <div class="tooltip-content v-center">
                <comp-icon class="pointer" [icon]="'info'" [size]="14" [color]="'hsla(216, 13%, 58%, 0.6)'"></comp-icon>
                <div class="tooltip">
                  <div class="tooltip-item">
                    <div class="tooltip-row" *ngIf="!isIncludesOtherEvents">Video clips created from alarm-triggered events using sensor inputs (DI), camera analytics (OE), or API triggers.</div>
                    <div class="tooltip-row" *ngIf="isIncludesOtherEvents">This is the total count of video clips stored for this location. It includes clips from alarm-triggered events, disarmed event activity, automation rules, timelapse recordings, and clips created through playback.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chart-box">
            <dashboard-chart [active]="staticsticsData.videoEvents.status" [data]="staticsticsData.videoEvents.chartData" [width]="260" [chartType]="'line'" [topSites]="staticsticsData.videoEvents.topSites" [updates]="staticsticsData.videoEvents.updates" [rangeLabel]="staticsticsData.timeData.range" (onHoverEvent)="onChartHover($event, staticsticsData.videoEvents)" (mouseout)="onChartMouseOut(staticsticsData.videoEvents)"></dashboard-chart>
          </div>
          <div class="statistics-widget-contents-box-time-range">
            <div class="statistics-widget-contents-box-time-stime">{{staticsticsData.videoEvents.stime}}</div>
            <div class="statistics-widget-contents-box-time-etime">{{staticsticsData.videoEvents.etime}}</div>
          </div>
        </div>
        <div class="disable-chart" *ngIf="staticsticsData.videoEvents.chartData.data.length === 0">No Data</div>
      </div>
      <!--  Monitoring Portal Open Chart-->
      <div class="statistics-widget-contents-box flex-group-2">
        <div class="statistics-widget-contents-box-title">
          <div class="flex">
            <div class="mr-5">Monitoring Portal Open</div>
            <div style="display: flex;">
              <div class="tooltip-content v-center">
                <comp-icon class="pointer" [icon]="'info'" [size]="14" [color]="'hsla(216, 13%, 58%, 0.6)'"></comp-icon>
                <div class="tooltip">
                  <div class="tooltip-item">
                    <div class="tooltip-row">The accumulated time that agents spent on a site viewing video through the CHeKT Monitoring Portal with averages.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="flex-row between">
            <div class="statistics-widget-contents-box-count">{{staticsticsData.monitoringTimeStat.total}}</div>
            <div class="nav" *ngIf="hasReadRolePermission">
              <ul class="dropdown-area" #statisticsRoleListDropdown>
                <li>
                  <div class="dropdown-label flex-row between" (click)="toggleStatisticsRoleListDropDownMenu()" style="min-width: 120px;">
                    <div>{{staticsticsData.roleData.range}}</div>
                    <div class="flex align-center ml-4">
                      <comp-icon class="transition" [icon]="'expend_more'" [size]="'16'" [color]="'hsla(0, 0%, 0%, 1)'" [class.rotate-reverse]="staticsticsData.roleDropdown.isShow"></comp-icon>
                    </div>
                  </div>
                  <div class="dropdown-box top-226" *ngIf="staticsticsData.roleDropdown.isShow">
                    <div class="dropdown-permission-label v-center" style="gap: 8px;">
                      <div>
                        {{ isViewingPartnerDealer ? 'Partner Dealer' : 'My Dealer' }} Permission Group
                      </div>
                    </div>

                    <!-- Dealer View Toggle (hasBothRoleLists일 때만 표시) -->
                    <div *ngIf="hasBothRoleLists" style="padding: 8px 12px; border-bottom: 1px solid #e0e0e0;">
                      <mat-slide-toggle
                        [(ngModel)]="isViewingPartnerDealer"
                        [labelPosition]="'after'"
                        (change)="changeDealerView()"
                        style="font-size: 12px; transform: scale(0.9);"
                      >
                        <span class="default-label">
                          {{ isViewingPartnerDealer ? 'Viewing Partner Dealer Roles' : 'Viewing My Dealer Roles' }}
                        </span>
                      </mat-slide-toggle>
                    </div>
                    <ul class="dropdown-box-menu" style="height: 150px; overflow: auto;">
                      <li class="dropdown-box-menu-item" *ngFor="let item of roleList" [class.selected]="item.label === staticsticsData.roleData.range" (click)="changeMonitoringRoleId(item.value)">
                        <div class="dropdown-box-menu-item-icon">
                          <comp-icon [icon]="'done'" [size]="'14'" [color]="'hsl(210, 100%, 56%)'" *ngIf="item.label === staticsticsData.roleData.range"></comp-icon>
                        </div>
                        <div>{{item.label}}</div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="statistics-widget-contents-box-sub-info">Average {{staticsticsData.monitoringTimeStat.avg}} • Openings {{staticsticsData.monitoringTimeStat.counts}} events</div>
          <div class="chart-box" *ngIf="staticsticsData.monitoringTimeStat.chartData.data.length !== 0">
            <dashboard-chart 
              [active]="staticsticsData.monitoringTimeStat.status" 
              [data]="staticsticsData.monitoringTimeStat.chartData" 
              [width]="260" [height]="80" [chartType]="'monitoring-bar'" 
              [topSites]="staticsticsData.monitoringTimeStat.topSites" 
              [updates]="staticsticsData.monitoringTimeStat.updates" 
              (onReady)="onChartReady($event, staticsticsData.monitoringTimeStat.chartData)"
            ></dashboard-chart>
          </div>
          <div class="statistics-widget-contents-box-time-range">
            <div class="statistics-widget-contents-box-time-stime">{{staticsticsData.monitoringTimeStat.stime}}</div>
            <div class="statistics-widget-contents-box-time-etime">{{staticsticsData.monitoringTimeStat.etime}}</div>
          </div>
        </div>
        <div class="disable-chart" *ngIf="staticsticsData.monitoringTimeStat.chartData.data.length === 0">No Data</div>
      </div>
    </div>
  </div>
  <!--  Trouble Statistics-->
  <div *ngIf="statisticsType.curType === statisticsType.types[1]">
    <div class="statistics-widget-contents flex-row flex-wrap">
      <!--  Offline Event Chart-->
      <div class="statistics-widget-contents-box flex-group-2">
        <div class="statistics-widget-contents-box-title">
          <div class="flex">
            <div class="mr-5">Offline Events</div>
            <div style="display: flex;">
              <div class="tooltip-content v-center">
                <comp-icon class="pointer" [icon]="'info'" [size]="14" [color]="'hsla(216, 13%, 58%, 0.6)'"></comp-icon>
                <div class="tooltip">
                  <div class="tooltip-item">
                    <div class="tooltip-row">The number of disconnect events from devices on this site.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="statistics-widget-contents-box-count">{{!staticsticsData.offlineEvents.isHovered ? staticsticsData.offlineEvents.count : staticsticsData.offlineEvents.hoverLabel}}</div>
        <div class="chart-box">
          <dashboard-chart [active]="staticsticsData.offlineEvents.status" [data]="staticsticsData.offlineEvents.chartData" [width]="260" [chartType]="'line'" [topSites]="staticsticsData.offlineEvents.topSites" [updates]="staticsticsData.offlineEvents.updates" [rangeLabel]="staticsticsData.timeData.range" (onHoverEvent)="onChartHover($event, staticsticsData.offlineEvents)" (mouseout)="onChartMouseOut(staticsticsData.offlineEvents)"></dashboard-chart>
        </div>
        <div class="statistics-widget-contents-box-time-range">
          <div class="statistics-widget-contents-box-time-stime">{{staticsticsData.offlineEvents.stime}}</div>
          <div class="statistics-widget-contents-box-time-etime">{{staticsticsData.offlineEvents.etime}}</div>
        </div>
      </div>
      <!--  Bypass Event Chart-->
      <div class="statistics-widget-contents-box flex-group-2">
        <div class="statistics-widget-contents-box-title">
          <div class="flex">
            <div class="mr-5">Bypass Events</div>
            <div style="display: flex;">
              <div class="tooltip-content v-center">
                <comp-icon class="pointer" [icon]="'info'" [size]="14" [color]="'hsla(216, 13%, 58%, 0.6)'"></comp-icon>
                <div class="tooltip">
                  <div class="tooltip-item">
                    <div class="tooltip-row">The number of bypass events from zones on this site.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="statistics-widget-contents-box-count">{{!staticsticsData.bypassEvents.isHovered ? staticsticsData.bypassEvents.count : staticsticsData.bypassEvents.hoverLabel}}</div>
        <div class="chart-box">
          <dashboard-chart [active]="staticsticsData.bypassEvents.status" [data]="staticsticsData.bypassEvents.chartData" [width]="260" [chartType]="'line'" [topSites]="staticsticsData.bypassEvents.topSites" [updates]="staticsticsData.bypassEvents.updates" [rangeLabel]="staticsticsData.timeData.range" (onHoverEvent)="onChartHover($event, staticsticsData.bypassEvents)" (mouseout)="onChartMouseOut(staticsticsData.bypassEvents)"></dashboard-chart>
        </div>
        <div class="statistics-widget-contents-box-time-range">
          <div class="statistics-widget-contents-box-time-stime">{{staticsticsData.bypassEvents.stime}}</div>
          <div class="statistics-widget-contents-box-time-etime">{{staticsticsData.bypassEvents.etime}}</div>
        </div>
      </div>
    </div>
  </div>
</div>